import React from 'react'
import { Typography, TableContainer, Paper, Table, TableBody, TableRow, TableCell, TextField } from '@mui/material'
import { numberFormatterLocale } from '../../fnTickit'

const TableTotal = ({ sTitle, nValue }) => {
    return (
        <>
            <Typography className="font-weight-500 margin-bt">{sTitle}</Typography>
            <TableContainer id='table-money-notes' component={Paper}>
                <Table >
                    <TableBody>
                        <TableRow>
                            <TableCell padding='none' align='center' style={{ minWidth: '100px', width: '100px' }}>จำนวนเงิน </TableCell>
                            <TableCell padding='none' >
                                <TextField
                                    id={"nTotalCurrency"}
                                    name={"nTotalCurrency"}
                                    variant={"outlined"}
                                    value={numberFormatterLocale(nValue, 2)}
                                    type={"text"}
                                    size={"small"}
                                    fullWidth={true}
                                    disabled
                                    inputProps={{
                                        style: {
                                            textAlign: "right",
                                        }
                                    }}
                                />
                            </TableCell>
                            <TableCell padding='none' align='center' style={{ minWidth: '50px', width: '50px' }}>บาท</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default TableTotal